import store from '..';
import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';

export interface INotification {
  show: boolean;
  text: string;
  color: string;
}

export interface IConfirmDialog {
  show: boolean;
  title: string;
  description: string;
  action: any;
  cancelAction: any;
}

export enum NotificationType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'WARNING',
  ERROR = 'error',
}

@Module({
  namespaced: true,
  name: 'layout',
  store,
  dynamic: true,
})
class LayoutStore extends VuexModule {
  public drawer: boolean = true;
  public dialog: IConfirmDialog = {
    // tslint:disable-next-line:no-empty
    action: () => {
    },
    // tslint:disable-next-line:no-empty
    cancelAction: () => {

    },
    description: '',
    show: false,
    title: '',
  };

  public loading: boolean = true;

  public notification: INotification = {
    show: false,
    text: '',
    color: 'success',
  };

  @Action
  public showNotification({ text, type = NotificationType.SUCCESS }: { text: string, type?: NotificationType }) {
    this.context.commit('setNotification', {
      show: true,
      text,
      color: type,
    } as INotification);
  }

  @Action
  public hideNotification() {
    this.context.commit('setNotification', {
      show: false,
      text: '',
      color: '',
    } as INotification);
  }

  @Action
  public showConfirmDialog({ title, description, action, cancelAction }: { title: string, description: string, action: any, cancelAction: any }) {
    this.context.commit('setConfirmDialog', {
      show: true,
      title,
      description,
      action,
      cancelAction,
    } as IConfirmDialog);
  }

  @Action
  public hideConfirmDialog() {
    this.context.commit('setConfirmDialog', {
      // tslint:disable-next-line:no-empty
      action: () => {
      },
      description: '',
      show: false,
      title: '',
    } as IConfirmDialog);
  }

  @Mutation
  public toggleDrawer() {
    this.drawer = !this.drawer;
  }

  @Mutation
  public setNotification(notification: INotification) {
    this.notification = { ...notification };
  }

  @Mutation
  public setConfirmDialog(dialog: IConfirmDialog) {
    this.dialog = { ...dialog };
  }

  @Mutation
  public setLoading(loading: boolean) {
    this.loading = loading;
  }
}

export const LayoutModule = getModule(LayoutStore);
